import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import ReactQuill from "react-quill";
import { modules, formats } from "../../utils/environment";
import "react-quill/dist/quill.snow.css";
import { Redirect } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import $ from "jquery";
const token = localStorage.getItem("token");
class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prices_disable_text: "",
      ads: "",
      members_increment: 0,
      visits_increment: 0
    };
  }
  componentDidMount() {
    document.title = "تنظیمات";
    this.props.socket !== null && this.getData(this.props.socket);
    $(document).mouseup(e => {
      var container = $(".clickable-area");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          this.setState({showEmoji:false})
          
      }
  });
  }
  componentWillReceiveProps(nextProps) {
    nextProps.socket !== null && this.getData(nextProps.socket);
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  getData = socket => {
    const token = localStorage.getItem("token");
    socket.once("settings", data => {
      console.log(data);
      this.setState({
        prices_disable_text: data.prices_disable_text,
        ads: data.ads,
        members_increment: data.members_increment,
        visits_increment: data.visits_increment
      });
    });
    socket.emit("settings", { token });
  };

  handleUpdateSettngs = () => {
    const {
      prices_disable_text,
      ads,
      members_increment,
      visits_increment
    } = this.state;
    const token = localStorage.getItem("token");
    const { socket } = this.props;
    socket.once("settings_update", data => {
      console.log(data);
      if (!data.error) {
        this.setState({ item: data.data, connected: socket.connected });
        this.setState({ go_login: false });
        this.setState({
          messageInfo: data.message,
          open: true,
          hasError: false
        });
      } else {
        this.setState({ go_login: false });
        this.setState({
          messageInfo: data.message,
          open: true,
          hasError: true
        });
      }
      if (data.message === "Invalid Token") {
        this.setState({ go_login: true });
      }
    });
    socket.emit("settings_update", {
      prices_disable_text,
      ads,
      members_increment,
      visits_increment,
      token
    });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleEmoji = () => {
    this.setState({ showEmoji: !this.state.showEmoji });
  };
  addEmoji = (e) => {
    //console.log(e.native)
    let emoji = e.native;
    this.setState({
      ads: this.state.ads.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "") + emoji,
        showEmoji: false
    })
}
  render() {
    const {
      go_login,
      showEmoji,
      messageInfo,
      open,
      hasError,
      prices_disable_text,
      ads,
      members_increment,
      visits_increment
    } = this.state;
    const emoji_setting = {
      search: 'جستجو',
      clear: 'پاک کردن', // Accessible label on "clear" button
      notfound: 'ایموجی یافت نشد',
      skintext: 'رنگ پوست پیش فرض خود را وارد نمایید',
      categories: {
          search: 'نتایج جستجو',
          recent: 'اخیرا استفاده شده',
          people: 'شکلک ها و افراد',
          nature: 'حیوانات و طبیعت',
          foods: 'غذا نوشیدنی',
          activity: 'فعالیت',
          places: 'مسافرت و مکان',
          objects: 'اشیاء',
          symbols: 'نمادها',
          flags: 'پرچم ها',
          custom: 'سفارشی',
      },
      categorieslabel: 'دسته بندی ایموجی', // Accessible title for the list of categories
      skintones: {
          1: 'تن پیش فرض پوست',
          2: 'تن پوست روشن',
          3: 'تن پوست با نور متوسط',
          4: 'تن پوست متوسط',
          5: 'تن پوست تیره متوسط',
          6: 'تن پوست تیره',
      },
  }
    return go_login ? (
      <Redirect to='/login?go-login="true' />
    ) : (
      <React.Fragment>
        <h1 className="h1 without-parent-padding">درباره ما</h1>
        <Card className="profile-card no-padding">
          <CardContent className="ap-tabpanel-wrapper">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={7} lg={10}>
                <div className="placeholer_tooltip">
                  <span style={{ color: "#656181" }}>تنظیمات</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} style={{ marginBottom: 15 }}>
                <TextField
                  label="متن غیرفعال سازی"
                  name="prices_disable_text"
                  value={prices_disable_text}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4} style={{ marginBottom: 15 }}>
                <TextField
                  label="تعداد کاربران"
                  name="members_increment"
                  value={members_increment}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4} style={{ marginBottom: 15 }}>
                <TextField
                  label="تعداد بازدیدها"
                  name="visits_increment"
                  value={visits_increment}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ marginBottom: 15 }} className="pr">
                <ReactQuill
                  modules={modules}
                  formats={formats}
                  placeholder="تبلیغات خود را در این قسمت وارد نمایید"
                  value={ads}
                  onChange={val => this.setState({ ads: val })}
                />
                <span className="cht-opt-btn clickable-area">
                  <i className="far fa-smile" onClick={this.handleEmoji}></i>
                </span>
                <span className="clickable-area">
                  {showEmoji ? (
                    <Picker
                      className="add-emoji "
                      title="شکلک خود را انتخاب نمایید"
                      emoji="point_up"
                      onSelect={this.addEmoji}
                      emojiSize={15}
                      i18n={emoji_setting}
                    />
                  ) : null}
                </span>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleUpdateSettngs}
              className="confirm-btn"
            >
              ذخیره
            </Button>
          </CardContent>
        </Card>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <Snackbar
          key={messageInfo ? messageInfo : undefined}
          className={hasError ? "error-msg" : "success-msg"}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={open}
          severity="success"
          autoHideDuration={6000}
          onClose={this.handleClose}
          onExited={this.handleClose}
          message={messageInfo ? messageInfo : undefined}
          action={
            <React.Fragment>
              <IconButton
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    socket: state.setSocket
  };
};
export default connect(mapStateToProps)(Setting);
